import { render, staticRenderFns } from "./MusicImport.vue?vue&type=template&id=2b4ded18&"
import script from "./MusicImport.vue?vue&type=script&lang=js&"
export * from "./MusicImport.vue?vue&type=script&lang=js&"
import style0 from "./MusicImport.vue?vue&type=style&index=0&lang=scss&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports